import React from 'react';
import ProjectPageInfo from '../components/ProjectPageInfo/ProjectPageInfo';

const desktopImages = [
  {
    id: 1, name: 'Homepage', url: '/images/desktop/ineos/index-desktop.jpg',
  },
  {
    id: 2, name: 'SRP', url: '/images/desktop/ineos/srp-desktop.jpg',
  },
  {
    id: 3, name: 'VDP', url: '/images/desktop/ineos/vdp-desktop.jpg',
  },
  {
    id: 4, name: 'Service', url: '/images/desktop/ineos/service-desktop.jpg',
  },
  {
    id: 5, name: 'Model', url: '/images/desktop/ineos/model-desktop.jpg',
  },
];

const mobileImages = [
  {
    id: 1, name: 'Homepage', url: '/images/mobile/ineos/index-mobile.jpg',
  },
  {
    id: 2, name: 'VDP', url: '/images/mobile/ineos/vdp-mobile.jpg',
  },
  {
    id: 3, name: 'SRP', url: '/images/mobile/ineos/srp-mobile.jpg',
  },
  {
    id: 4, name: 'Service', url: '/images/mobile/ineos/service-mobile.jpg',
  },
  {
    id: 5, name: 'Model', url: '/images/mobile/ineos/model-mobile.jpg',
  }
];

const Ineos = () => (
  <>
      <ProjectPageInfo
        title="Ineos Grenadier"
        icon="bi bi-geo-fill"
        location="Lake Bluff, IL"
        liveUrl="https://www.knauzineosgrenadier.com/"
        desktopImages={desktopImages}
        mobileImages={mobileImages}
        backgroundColor="#011e40"
        backgroundColorTwo="#01254f"
        heroImage="/images/project-page/ineos/ineos-hero.png"
        imacIpad="/images/project-page/ineos/ineos-imac-ipad.png"
        phoneOne="/images/project-page/ineos/ineos-phone.png"
        phoneTwo="/images/project-page/ineos/ineos-iphone-2.png"
      />
  </>
);

export default Ineos;

